import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Heart } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 bg-botanical-ivory relative overflow-hidden" data-id="element-137">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-botanical-forest via-botanical-gold to-botanical-forest opacity-20" data-id="element-138"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white p-8 md:p-16 rounded-sm shadow-xl border border-botanical-gold/20 relative" data-id="element-140">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-botanical-forest text-botanical-ivory px-6 py-2 rounded-full font-lora text-sm tracking-widest uppercase flex items-center gap-2" data-id="element-141">
            <Heart size={14} className="text-botanical-gold" data-id="element-142" />
            Tu piel lo merece
          </div>

          <p className="text-xl md:text-2xl font-lora text-botanical-forest/80 mb-8 mt-4" data-id="element-143">
            No necesitas gastar{' '}
            <span className="line-through text-botanical-terracotta/70" data-id="element-144">
              $100
            </span>{' '}
            en un suero que no entiendes. Aprende a crear tu propia belleza
            esencial por el precio de un par de cafés.
          </p>

          <div className="mb-10" data-id="element-145">
            <p className="font-playfair text-botanical-forest text-lg mb-2 uppercase tracking-wider" data-id="element-146">
              Oferta Especial de Lanzamiento
            </p>
            <div className="text-6xl md:text-7xl font-playfair font-bold text-botanical-gold" data-id="element-147">
              $8.39{' '}
              <span className="text-2xl text-botanical-gold/70 font-normal" data-id="element-148">
                USD
              </span>
            </div>
          </div>

          <motion.div animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          repeat: Infinity,
          duration: 3,
          ease: 'easeInOut'
        }} className="inline-block" data-id="element-149">
            <a href="https://vitalizateahora.com/cart/51901429055719:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-botanical-gold text-white font-lora font-medium text-sm md:text-lg w-full md:w-auto py-5 px-10 rounded-sm shadow-[0_4px_20px_rgba(196,151,59,0.3)] hover:bg-botanical-gold-light hover:shadow-[0_4px_25px_rgba(212,168,83,0.4)] hover:scale-105 active:scale-95 transition-all duration-300 text-center cursor-pointer" data-id="element-150">
              Obtener mi guía de piel sana
            </a>
          </motion.div>

          <div className="mt-8 flex items-center justify-center gap-2 text-botanical-forest/60 font-lora text-sm" data-id="element-151">
            <Shield size={16} data-id="element-152" />
            <span data-id="element-153">Pago seguro y descarga instantánea.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}